import { SafeString } from 'handlebars/dist/handlebars';

import { createLink } from 'rise-ui/utils/dynamic-node/utils/create-link.js';

export function cFeature(...args) {
  const options = args.pop();
  let { tooltip } = options.hash;
  const link = createLink(args, options);
  const isLink = args.length;
  tooltip = tooltip ? ` title="${tooltip}"` : '';
  const linkClass = isLink ? ' c-clickable' : '';
  const linkAttrs = isLink ? ` role="button" id="${link.id}"${tooltip}` : '';
  return new SafeString(
    `<div class="c-features__feature c-feature${linkClass}"${linkAttrs}${tooltip}>${options.fn(this)}</div>`,
  );
}
